import { cn } from "@newxsystems/shared";
import type { IDaylightSectionProps } from "./DaylightSection.props";

export const DaylightSection = ({
  children,
  className,
  containerClassName,
  containerWidth = "default",
  id,
  spacing,
}: IDaylightSectionProps) => (
  <section
    className={cn("daylight-block-spacing bg-background text-foreground", className)}
    data-spacing={spacing || undefined}
    id={id || undefined}
  >
    <div
      className={cn("daylight-container", containerClassName)}
      data-container-width={containerWidth}
    >
      {children}
    </div>
  </section>
);

DaylightSection.displayName = "Content::DaylightSection";
